import CampaignMedia from './CampaignMedia';
import CampaignLink from './CampaignLink';
import './CampaignStrip.css';

/** A row of small clickable promo cards between the main home sections. */
const CampaignStrip = ({ campaigns = [] }) => {
  if (!campaigns.length) return null;

  return (
    <section className="campaign-strip">
      <div className="campaign-strip-grid">
        {campaigns.map((campaign, index) => (
          <CampaignLink
            key={campaign.id}
            campaign={campaign}
            className="campaign-strip-card"
            data-reveal-item=""
            style={{ '--reveal-index': index + 1 }}
            aria-label={campaign.title}
          >
            <CampaignMedia campaign={campaign} as="h3" />
          </CampaignLink>
        ))}
      </div>
    </section>
  );
};

export default CampaignStrip;
